import React from 'react';
import { Heading } from '../Heading';
import { Container } from '../Container';
import { TemplateContent } from './TemplateContent';

export function AdminConsoleCommunicationTemplate() {
  return (
    <Container>
      <Heading title='Templates' subtitle='Manage and customize communication templates for your organization' />
      <TemplateContent />
    </Container>
  );
}
